export default "__VITE_ASSET__DmxcTAba__"